module.exports = __webpack_public_path__ + "static/img/fjw.e0260aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myteam/fjw.png
// module id = Mia0
// module chunks = 1